import _ from 'lodash';
import { FormioCustomEvent } from 'src/core/Formio.types';
import { Router } from 'src/core/router/Router';
import {
    ComponentEventInstance,
    ContextNames,
    ProcessContextDefenition,
} from 'src/stores/ProcessStore/ProcessContextDefenition.util';
import { ProcessStoreProvider } from 'src/stores/ProcessStore/ProcessStore';

export const handleStartProcessCustomEvent = (
    event: FormioCustomEvent,
    entityBaseUrl: string,
) => {
    const { properties } = event.component as FormioCustomEventComponent;

    if (!properties?.processKey) {
        return;
    }

    const {
        processKey,
        context: contextKey,
        useContextWrapper: useContextWrapperValue,
    } = properties;

    const process = ProcessStoreProvider.getInstance(processKey);

    if (_.has(properties, 'useContextWrapper')) {
        const useContextWrapper = useContextWrapperValue !== 'false';
        process.setUseContextWrapper(useContextWrapper);
    }

    if (contextKey) {
        const context = ProcessContextDefenition(
            contextKey,
            event as ComponentEventInstance,
        );
        process.setContext(context);
    }

    Router.navigate(`${entityBaseUrl}/process/${processKey}`);
};

export type FormioCustomEventComponent = Record<string, any> & {
    properties?: ComponentProperties;
};

type ComponentProperties = {
    processKey: string;
    context?: ContextNames;
    useContextWrapper?: string;
    entity?: string;
    urlParams?: string;
};
